import styled from 'styled-components'

export const Container = styled.div`
  ul {
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
    box-sizing: border-box;
  }

  a {
    display: block;
    color: ${props => props.theme.palette.general.strong};
    padding: 18px 14px;
    text-decoration: none;
    border-top: 1px solid ${props => props.theme.palette.general.greyLight};
    -webkit-tap-highlight-color: transparent;
  }

  .hasChildren {
    position: relative;

    > svg {
      position: absolute;
      right: 14px;
      top: 19px;
      transform: rotate(0deg);
      transition: transform 300ms ease;
      pointer-events: none;
      fill: ${props => props.theme.palette.general.grey};
      width: 15px;
      height: 15px;
    }

    ul {
      padding: 0 0 0 1em;
    }
  }

  .isChildrenVisible {
    > svg {
      transform: rotate(180deg);
    }
  }

  > ul {
    > li {
      > a {
        color: ${props => props.theme.palette.general.strong};
        background: ${props => props.theme.palette.general.soft};
        border-top: 1px solid ${props => props.theme.palette.general.greyLight};
      }

      &.hasChildren {
        > div {
          .isChildrenVisible {
            > a,
            > svg {
              fill: ${props => props.theme.palette.primary.beta};
            }
          }
        }

        > svg {
          fill: ${props => props.theme.palette.general.strong};
        }

        li {
          ul {
            a {
              color: ${props => props.theme.palette.general.greyDark};
            }
          }
        }
      }

      &.isChildrenVisible {
        > a {
          background: ${props => props.theme.palette.primary.alpha};
          color: ${props => props.theme.palette.general.soft};
        }

        > svg {
          fill: ${props => props.theme.palette.general.soft};
        }
      }
    }
  }
`
